import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'
import { I621Form } from 'legacy/lut/features/partner360/configuration'

import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'

export const getJBPPartnerBasicInfoCrud = (keySuffix?: string) => {
  return CrudStore.get(
    CrudStoreItemPartner360.PartnerBasicInfo,
    keySuffix ? `JBPPartnerData:${keySuffix}` : 'JBPPartnerData'
  ) as Crud<I621Form>
}
